import Vue from "vue";
import resError from "./ajax/res-error";
import intercptorsReq from "./ajax/interceptors-req";
import argsCheck from "./ajax/args-check";
import resCheck from "./ajax/res-check";

var ajaxKeyMap = function (type) {
  return [
    ["type", "method"],
    ["url", "url"],
    ["data", type === "post" ? "data" : "params"],
    ["callback", "callback"],
    ["error", "error"],
    ["complete", "complete"],
    ["fztype", "fztype"],
    ["headers", "headers"],
  ];
};

var mixin = (axios, app) => {
  function $get(a, b, c, d) {
    var settings = argsCheck(a, b, c, d);

    settings.type = "get";
    settings = intercptorsReq(settings, app);

    axios
      .get(settings.url, {
        params: settings.data,
        headers: settings.headers,
      })
      .then(([data, res]) => {
        settings.callback.call(this, data, res);
      })
      .catch((err) => {
        if (err.response) {
          resError(err.response, settings, app);
        } else {
          console.error({
            err,
            settings,
          });
        }
      });
  }

  function $post(a, b, c, d) {
    var settings = argsCheck(a, b, c, d);

    settings.type = "post";
    settings = intercptorsReq(settings, app);

    axios
      .post(settings.url, settings.data, {
        headers: settings.headers,
      })
      .then(([data, res]) => {
        settings.callback.call(this, data, res);
      })
      .catch((err) => {
        if (err.response) {
          resError(err.response, settings, app);
        } else {
          console.error({
            err,
            settings,
          });
        }
      });
  }

  function $ajax(settings) {
    var keyMap = ajaxKeyMap(settings.type),
      axiosSetting = {};

    keyMap.forEach((item) => {
      axiosSetting[item[1]] = settings[item[0]];
    });

    axiosSetting = intercptorsReq(axiosSetting, app);

    axios(axiosSetting)
      .then(([data, res]) => {
        axiosSetting.callback && axiosSetting.callback.call(this, data, res);
      })
      .catch((err) => {
        if (err.response) {
          resError(err.response, axiosSetting, app);
        } else {
          console.error({
            err,
            settings,
          });
        }
      })
      .finally(() => {
        axiosSetting.complete && axiosSetting.complete.call(this);
      });
  }

  Vue.prototype.$get = $get;
  Vue.prototype.$post = $post;
  Vue.prototype.$ajax = $ajax;

  app.$get = $get;
  app.$post = $post;
  app.$ajax = $ajax;
};

var resInterceptors = (data, config, header, context) => {
  return resCheck(
    data,
    config,
    (data, res) => {
      return [data, res];
    },
    context
  );
};

export default {
  mixin,
  resInterceptors,
};
